import type { FaireProductEntity } from "../../entity_types/product";

export const p_dc8n8edeq9: FaireProductEntity = {
  token: "p_dc8n8edeq9",
  type: "product",
  name: "MUD WITCH MINI FRAME BLIND BOX •GROCERY SERIES• ASSORTMENT",
  brandToken: "b_3sbdu0huip",
  brandName: "MUD WITCH",
  imageUrl:
    "https://cdn.faire.com/fastly/9f43569b991fb751e9b291bb3efe50e4d2922204563f7ba4c3d848ea8092dd0f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f9445e8c9564ea31685e960d0bfb05ecc2892333f3f55adabad35a8d6fe661da.jpeg",
  ],
  priceDollars: 16.8,
  description:
    "Looking or some great add ons? Try these art blind boxes! Different fruits and veggies moni frames all handmade. Think of it as a stylish ceramic surprise bag. Yes, please.\n\nEach one is carefully curated within a dreamy color palette, so whatever lands on your doorstep, it’s going to look good. And let’s be honest, when it’s a mystery drop, people always want more than one.\n",
  tags: [],
  msrpDollars: 33.6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:57.595Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
